/* Geane Party — dismiss desktop department menu on outside interaction */
(function(){
 function init(){
  var root=document.querySelector('[data-gp-retail-navigation]');
  if(!root||root.dataset.gpPcReady==='1')return;
  root.dataset.gpPcReady='1';
  var menu=root.querySelector('[data-gp-pc-department]');
  if(!menu)return;
  document.addEventListener('pointerdown',function(e){
   if(menu.open&&!menu.contains(e.target))menu.open=false;
  });
  document.addEventListener('keydown',function(e){
   if(e.key==='Escape'&&menu.open){menu.open=false;var trigger=menu.querySelector('summary');if(trigger)trigger.focus();}
  });
  window.addEventListener('resize',function(){if(window.innerWidth<=990&&menu.open)menu.open=false;});
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',init);
})();